export default __webpack_public_path__ + "static/media/strong 4 core.fc10298c.jpg";